import { Box, Button, Group, Image, Text, Title } from '@mantine/core'
import { Form, Link } from '@remix-run/react'
import type { AdminSessionInfo } from '~/authenticator.server'

const PROJECT_YEAR = import.meta.env.VITE_PROJECT_YEAR

export const AdminHeader = ({
  adminUserInfo,
}: { adminUserInfo: AdminSessionInfo | null }) => {
  return (
    <Box
      h='100%'
      style={{
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Group mx='lg' align='center' h='100%' justify='space-between'>
        <Link to='/admin'>
          <Image
            h='40px'
            src={PROJECT_YEAR ? `/logo-${PROJECT_YEAR}.svg` : '/basic-logo.svg'}
            alt={`シンアド就活${PROJECT_YEAR}のロゴ画像`}
          />
        </Link>
        <Title>管理画面</Title>
        {adminUserInfo ? (
          <Group>
            <Text>{adminUserInfo.name}</Text>
            <Form method='POST' action='/logout'>
              <Button type='submit' variant='light'>
                ログアウト
              </Button>
            </Form>
          </Group>
        ) : null}
      </Group>
    </Box>
  )
}
